<script lang="ts">
  import { type TAvailableLoginMethod } from "../../../../utils/types";
  import Container from "../../shared/Container.svelte";
  import Loader from "../../shared/Loader.svelte";
  import AuthButton from "./AuthButton.svelte";

  export let options: {
    loginMethods: TAvailableLoginMethod[];
    handleLogin: (method: TAvailableLoginMethod) => void;
    isLoading: boolean;
  };

  let { loginMethods, handleLogin, isLoading } =
    options;
</script>

{#if !isLoading}
  <Container>
    {#if loginMethods.length === 0}
      <div class="crtw-text-center crtw-text-gray-500 crtw-text-sm">
        No login methods available for this client.
      </div>
    {:else}
      {#each loginMethods as method}
        <AuthButton handler={() => handleLogin(method)}>
          {method.text}
        </AuthButton>
      {/each}
    {/if}
  </Container>
{:else}
  <div class="crtw-m-5">
    <Loader />
  </div>
{/if}
